export function validate(input?: string) {
  return input?.length && input.includes("@"); // TODO: Подключить логику паттерна логина
}